import { CmsMeta } from '../cms/cmsMeta';
import { useConfig } from '../../config';
import { useFormatting, useTranslation } from '../../i18n/i18n';
import { UiContainer } from '../../state/ui';
import './PriceTagSimple.css';
import { ProductContainer } from '../../state/product';
import { ProductUnits } from '../../i18n/sv';
import { calculateVatMultiplier } from '../../utils/vatUtils';

export const PriceTagSimple = ({
	price,
	vatRate,
	isCampaign = false,
	unit = '',
	onlyText = false,
	decimals = 2,
}: {
	price: number;
	vatRate: number;
	isCampaign?: boolean;
	unit?: string;
	onlyText?: boolean;
	decimals?: number;
}): JSX.Element => {
	const ui = UiContainer.useContainer();
	const { asPrice } = useFormatting();
	const { currency, currencyCode } = useConfig();
	const vatScale = calculateVatMultiplier(vatRate, ui.priceWithVat);
	const t = useTranslation().product;

	if (onlyText) {
		return (
			<>
				{asPrice(price * vatScale, decimals)}
				{unit != '' && '/' + t.units[unit as keyof ProductUnits]}
			</>
		);
	}

	return (
		<div className={'product-price price-tag-simple' + (isCampaign ? ' campaign' : '')}>
			<strong className="price">
				{asPrice(price * vatScale, decimals, true, false)}
				<span className="product-unit">
					{/*
					 * The space asPrice used to leave trailing when asked for a bare amount, which
					 * is what every product box was relying on. Non-breaking, so the amount and
					 * its symbol cannot end up on separate lines.
					 */}
					{currencyCode != 'EUR' && '\u00a0' + currency}
					{unit != '' && '/' + t.units[unit as keyof ProductUnits]}
				</span>
			</strong>
		</div>
	);
};

export function getSpecialPrice(productId: number): number | undefined {
	const { specialPricesIndex } = ProductContainer.useContainer();
	if (specialPricesIndex) {
		const specialPrice = specialPricesIndex[productId];
		if (specialPrice) {
			return specialPrice.newPrice;
		}
	}
}

export const cmsMeta: CmsMeta = {
	description:
		'A price written the way the market writes prices. `price` is in whole currency units, so 200 means two hundred - it is not divided by 100. `vatRate` is the exception: it is in basis points, so 1900 is 19%. The rate is applied only when the reader sees prices including vat.',
	example: ['PriceTagSimple', { index: 1, price: '200', vatRate: '1900', decimals: 0, onlyText: true }],
};
